/* FUT7 — Black November 2026 e melhorias da home que ficam depois dela. Ver snippets/f7-bn.liquid.
   Porta do bn-pages.js / bn-cart.js da prévia aprovada pelo dono (pacote "FUT7-Black-November", HANDOFF §4), sobre o
   HTML real do tema. Sem bibliotecas.
   - Sempre (window.F7X): escudos em "O que está a sair", emblemas das ligas em "Todas as equipas", botão "+" nos
     cartões com folha de tamanhos.
   - Só na campanha (window.F7BN): contagem do topo, "€X cada no pack de 12" nos cartões, 3 cabides com camisolas reais,
     "Como poupar mais", pergunta da Black November no FAQ, cores do clube no topo da coleção.
   Nome de clube só por código: o nome vem sempre do mapa [data-f7-clubes]. */
(function(){
  'use strict';
  var X = window.F7X, BN = window.F7BN;
  if (!X || window.F7BNReady) return;
  window.F7BNReady = true;
  var T = X.t || {};
  var $ = function(s, r){ return (r || document).querySelector(s); };
  var $$ = function(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function(t){ return String(t == null ? '' : t).replace(/[&<>"']/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var fill = function(s, o){ return String(s || '').replace(/\{(\w+)\}/g, function(_, k){ return o[k] != null ? o[k] : ''; }); };
  var ROOT = X.root && X.root !== '/' ? X.root + '/' : '/';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  /* Dinheiro no formato da própria loja: copia o símbolo e o separador do primeiro preço da página ("€35,99") */
  var FMT = null;
  var money = function(cents){
    if (!FMT) {
      var s = $('.f7-h-pcard__price span, .f7-h-pcard__price, .price-item--regular, .price-item');
      var m = s && String(s.textContent).replace(/\s+/g, ' ').trim().match(/^(.*?)(\d[\d.,' ]*\d|\d)(.*)$/);
      if (m) { var dec = /[.,]\d{2}$/.test(m[2]) ? m[2].charAt(m[2].length - 3) : ','; FMT = { pre: m[1], suf: m[3], dec: dec, th: dec === ',' ? '.' : ',' }; }
    }
    if (!FMT) { try { return new Intl.NumberFormat(document.documentElement.lang || 'pt-PT', { style: 'currency', currency: CUR }).format((cents || 0) / 100); } catch (e) { return ((cents || 0) / 100).toFixed(2); } }
    var parts = ((cents || 0) / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, FMT.th);
    return FMT.pre + parts.join(FMT.dec) + FMT.suf;
  };
  var CLUBS = null;
  var clubName = function(handle){
    if (!CLUBS) {
      CLUBS = {};
      var pt = /^pt/i.test(document.documentElement.lang || '');
      try { JSON.parse($('[data-f7-clubes]').textContent).forEach(function(c){ if (c && c.c && !CLUBS[c.c]) CLUBS[c.c] = pt ? c.n : (c.ne || c.n); }); } catch (e) {}
    }
    var p = String(handle || '').split('-');
    for (var i = p.length - 1; i >= 0; i--) { if (/^\d{3}$/.test(p[i]) && CLUBS[p[i]]) return CLUBS[p[i]]; }
    return '';
  };
  var ready = function(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); };

  /* ---------- Topo: contagem até 30/11 23:59 (Lisboa) ---------- */
  var tickTop = function(){
    var b = $$('[data-f7-bn-cd]');
    if (!b.length || !BN) return;
    var go = function(){
      var ms = Math.max(0, Date.parse(BN.end) - Date.now()), p = function(n){ return (n < 10 ? '0' : '') + n; };
      var v = { d: p(Math.floor(ms / 864e5)), h: p(Math.floor(ms / 36e5) % 24), m: p(Math.floor(ms / 6e4) % 60), s: p(Math.floor(ms / 1e3) % 60) };
      b.forEach(function(el){ el.textContent = v[el.getAttribute('data-f7-bn-cd')]; });
    };
    go(); setInterval(go, 1000);
  };

  /* ---------- Cartões de produto: "€X cada no pack de 12" (campanha) e botão "+" com folha de tamanhos ---------- */
  var priceOf = function(txt){
    var m = String(txt || '').replace(/\s/g, ' ').match(/(\d{1,3}(?:[.  ]\d{3})*|\d+)(?:([.,])(\d{2}))?(?!\d)/);
    if (!m) return 0;
    return Math.round(parseFloat(m[1].replace(/[.  ]/g, '') + '.' + (m[3] || '00')) * 100);
  };
  var decorate = function(root){
    $$('.f7-h-pcard', root).forEach(function(c){
      if (c.getAttribute('data-f7-bn')) return;
      c.setAttribute('data-f7-bn', '1');
      var pr = $('.f7-h-pcard__price', c);
      if (BN && pr) {
        var v = priceOf((pr.querySelector('span') || pr).textContent);
        if (v) pr.insertAdjacentHTML('afterend', '<p class="f7-bn-pk">' + esc(fill(T.pack_each, { price: money(Math.round(v * 5 / 12)) })) + '</p>');
      }
      var media = $('.f7-h-pcard__media', c), h = c.getAttribute('data-handle');
      if (media && h && !/mystery|combo/.test(h)) media.insertAdjacentHTML('afterend', '<button type="button" class="f7-bn-qa" data-f7-bn-qa="' + esc(h) + '" aria-label="' + esc(T.quick_add) + '">+</button>');
    });
  };
  var sheet = null;
  var closeSheet = function(){ if (sheet) { sheet.classList.remove('is-open'); sheet.setAttribute('aria-hidden', 'true'); } };
  var quickAdd = function(handle){
    var X_ICO = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    if (!sheet) {
      sheet = document.createElement('div');
      sheet.className = 'f7-bn-sheet';
      sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-hidden', 'true');
      document.body.appendChild(sheet);
      sheet.addEventListener('click', function(e){
        if (e.target === sheet || e.target.closest('[data-f7-bn-sx]')) { closeSheet(); return; }
        var b = e.target.closest('[data-f7-bn-sv]');
        if (!b) return;
        b.classList.add('is-on');
        var id = b.getAttribute('data-f7-bn-sv');
        var add = window.F7Cart && F7Cart.add ? F7Cart.add(id) : fetch(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) }).then(function(){ return window.F7Cart && F7Cart.open(); });
        Promise.resolve(add).then(closeSheet, closeSheet);
      });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeSheet(); });
    }
    sheet.innerHTML = '<div class="f7-bn-sheet__in"><p class="f7-bn-sheet__load">' + esc(T.sheet_loading) + '</p></div>';
    sheet.classList.add('is-open'); sheet.setAttribute('aria-hidden', 'false');
    fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' }).then(function(r){ if (!r.ok) throw r; return r.json(); }).then(function(p){
      var n = clubName(p.handle), title = n && String(p.title).indexOf(n) < 0 ? n + ' ' + p.title : p.title;
      var img = String(p.featured_image || '').replace(/^\/\//, 'https://');
      var sizeOpt = 0;
      (p.options || []).forEach(function(o, i){ if (/size|tamanho|taglia|taille|talla/i.test(o.name || o)) sizeOpt = i; });
      sheet.innerHTML = '<div class="f7-bn-sheet__in"><button type="button" class="f7-bn-sheet__x" data-f7-bn-sx aria-label="' + esc(T.close) + '">' + X_ICO + '</button>' +
        '<div class="f7-bn-sheet__p">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" width="76" height="76">' : '') +
        '<div><b>' + esc(title) + '</b><span>' + esc(money(p.price)) + '</span>' + (BN ? '<small>' + esc(fill(T.pack_each, { price: money(Math.round(p.price * 5 / 12)) })) + '</small>' : '') + '</div></div>' +
        '<p class="f7-bn-sheet__l">' + esc(T.sheet_size) + '</p>' +
        '<div class="f7-bn-sheet__s">' + p.variants.map(function(v){ var o = (v.options && v.options[sizeOpt]) || v.title; return '<button type="button" data-f7-bn-sv="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(o) + '</button>'; }).join('') + '</div>' +
        '<a class="f7-bn-sheet__more" href="' + esc(ROOT + 'products/' + p.handle) + '">' + esc(T.sheet_more) + '</a></div>';
      var f = sheet.querySelector('button:not([disabled])'); if (f) try { f.focus({ preventScroll: true }); } catch (e) {}
    }).catch(function(){ closeSheet(); if (window.F7Cart && F7Cart.toast) F7Cart.toast(T.sheet_error); });
  };
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-f7-bn-qa]');
    if (b) { e.preventDefault(); e.stopPropagation(); quickAdd(b.getAttribute('data-f7-bn-qa')); }
  }, true);

  /* ---------- Home ---------- */
  var home = function(){
    /* "O que está a sair": escudos em vez do nome; Benfica, Porto, Sporting e Portugal primeiro */
    var FIRST = ['025', '026', '027', '703'];
    $$('.f7-h-rail__chips').forEach(function(bar){
      if (bar.classList.contains('f7-h-clubs__tabs')) return;
      var chips = $$('.f7-h-chip[data-code]', bar);
      if (!chips.length || !chips.every(function(c){ return X.crests && X.crests[c.getAttribute('data-code')]; })) return;
      chips.sort(function(a, b){ return ((FIRST.indexOf(a.getAttribute('data-code')) + 1) || 99) - ((FIRST.indexOf(b.getAttribute('data-code')) + 1) || 99); }).forEach(function(c){
        var code = c.getAttribute('data-code');
        if (!c.getAttribute('aria-label')) c.setAttribute('aria-label', c.textContent.trim() || clubName('x-' + code));
        c.classList.add('f7-bn-crest');
        c.innerHTML = '<img src="' + esc(X.crests[code]) + '" alt="" width="30" height="30" loading="lazy">';
        bar.appendChild(c);
      });
    });
    /* "Todas as equipas": emblema da liga num círculo branco antes do nome */
    var ALIAS = { 'National teams': 'Seleções', 'Nazionali': 'Seleções', 'Selezioni': 'Seleções', 'Saudi League': 'Liga Saudita', 'Saudi Pro League': 'Liga Saudita', 'Lega Saudita': 'Liga Saudita', 'Saudi Arabia': 'Liga Saudita' };
    $$('.f7-h-clubs__tabs .f7-h-chip').forEach(function(c){
      if (c.classList.contains('f7-bn-lg')) return;
      var name = c.firstChild && c.firstChild.textContent.trim(), src = X.leagues && (X.leagues[name] || X.leagues[ALIAS[name]]);
      if (!src) return;
      c.classList.add('f7-bn-lg');
      c.insertAdjacentHTML('afterbegin', '<img src="' + esc(src) + (/\/files\//.test(src) ? (src.indexOf('?') > -1 ? '&' : '?') + 'width=80' : '') + '" alt="" width="22" height="22" loading="lazy">');
    });
    if (!BN) return;

    /* Bloco do pack: 3 cabides de madeira com camisolas reais que balançam e dão a volta; terceiro nível 12 */
    var kits = $$('.f7-h-bundle .f7-h-kit');
    if (kits[1] && kits.length === 2) {
      var k12 = kits[1].cloneNode(true);
      var num = $('.f7-h-kit__num', k12); if (num) num.textContent = '12';
      var bd = $('.f7-h-kit__badge', k12); if (bd) bd.textContent = T.new;
      var cb = $('.f7-h-kit__cap b', k12); if (cb) cb.textContent = T.t12_title;
      var cs = $('.f7-h-kit__cap small', k12); if (cs) cs.textContent = T.t12_home;
      kits[1].classList.remove('f7-h-kit--best');
      var b7 = $('.f7-h-kit__badge', kits[1]); if (b7) b7.remove();
      kits[1].parentNode.insertBefore(k12, kits[1].nextSibling);
      var tiers = $('.f7-h-bundle__tiers');
      tiers.classList.add('f7-bn-rack');
      tiers.insertAdjacentHTML('afterend', '<p class="f7-bn-pack-cp">' + T.pack_coupon_html + '</p>');
      var RACK = [['benfica', 'realmadrid', 'braga'], ['porto', 'barcelona', 'city'], ['sporting', 'psg']];
      var TAGS = [['3', 1], ['7', 4], ['12', 7]];
      var img = function(k){ return (X.shirts && X.shirts[k]) || ''; };
      var HANGER = '<svg class="f7-bn-hg__hanger" viewBox="0 0 120 44" aria-hidden="true"><defs><linearGradient id="f7-bn-wood" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stop-color="#e2b47c"/><stop offset="1" stop-color="#8f5f33"/></linearGradient><linearGradient id="f7-bn-chrome" x1="0" x2="1"><stop offset="0" stop-color="#8d9098"/><stop offset=".5" stop-color="#f4f5f7"/><stop offset="1" stop-color="#7c7f87"/></linearGradient></defs>' +
        '<path d="M60 30V15a7 7 0 1 1 7-7" fill="none" stroke="url(#f7-bn-chrome)" stroke-width="3" stroke-linecap="round"/><path d="M8 41Q60 21 112 41" fill="none" stroke="url(#f7-bn-wood)" stroke-width="7" stroke-linecap="round"/><rect x="53" y="27" width="14" height="9" rx="3" fill="url(#f7-bn-wood)"/></svg>';
      $$('.f7-h-bundle .f7-h-kit').forEach(function(kit, i){
        var list = RACK[i] || RACK[0], tg = TAGS[i] || TAGS[0], shirt = $('.f7-h-kit__shirt', kit);
        if (!shirt || !img(list[0])) return;
        var wrap = document.createElement('div');
        wrap.className = 'f7-bn-hg'; wrap.style.setProperty('--i', i);
        wrap.innerHTML = '<div class="f7-bn-hg__swing" style="animation-delay:' + (-i * 1.7) + 's">' + HANGER +
          '<div class="f7-bn-hg__turn"><img class="f7-bn-hg__shirt" src="' + esc(img(list[0])) + '" alt="" width="260" height="280" loading="lazy"></div>' +
          '<span class="f7-bn-hg__tag' + (i === 2 ? ' is-hot' : '') + '"><b>' + tg[0] + '</b><i>' + esc(fill(T.free_n, { n: tg[1] })) + '</i></span></div>';
        shirt.parentNode.replaceChild(wrap, shirt);
        if (reduce || list.length < 2) return;
        /* Velocidade (v17): sem o brilho com máscara (a máscara pedia a imagem como PNG de ~110 KB em vez do webp de
           17 KB); as camisolas seguintes só descarregam depois de a página carregar; fora do ecrã o cabide para. */
        var at = 0, vis = true, started = false;
        if ('IntersectionObserver' in window) new IntersectionObserver(function(es){ vis = es[0].isIntersecting; wrap.classList.toggle('is-off', !vis); }).observe(wrap);
        var start = function(){
          if (started) return; started = true;
          list.slice(1).forEach(function(k){ var pre = new Image(); pre.src = img(k); });
          setTimeout(function(){
            setInterval(function(){
              if (document.hidden || !vis) return;
              var turn = $('.f7-bn-hg__turn', wrap);
              turn.classList.remove('is-turn'); void turn.offsetWidth; turn.classList.add('is-turn');
              setTimeout(function(){
                at = (at + 1) % list.length;
                $('.f7-bn-hg__shirt', turn).src = img(list[at]);
              }, 420);
            }, 3900);
          }, 1500 + i * 1300);
        };
        if (document.readyState === 'complete') start(); else { window.addEventListener('load', start, { once: true }); setTimeout(start, 8000); }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function(es, io){ if (es[0].isIntersecting) { tiers.classList.add('f7-bn-in'); io.disconnect(); } }, { threshold: .25 }).observe(tiers);
      } else tiers.classList.add('f7-bn-in');
      var ey = $('.f7-h-bundle .f7-h-eyebrow'); if (ey) ey.textContent = T.eyebrow;
      /* "Como poupar mais": 3 passos logo a seguir */
      var sec = $('.f7-h-bundle').closest('.shopify-section') || $('.f7-h-bundle');
      var cta = X.news || X.shop;
      sec.insertAdjacentHTML('afterend', '<section class="f7-bn-how"><div class="page-width">' +
        '<p class="f7-bn-how__e">' + esc(T.how_e) + '</p><h2 class="f7-bn-how__h">' + esc(T.how_h) + '</h2><ol class="f7-bn-how__list">' +
        '<li><b>1</b><span><strong>' + esc(T.how_1t) + '</strong>' + esc(T.how_1s) + '</span></li>' +
        '<li><b>2</b><span><strong>' + esc(T.how_2t) + '</strong>' + esc(T.how_2s) + '</span></li>' +
        '<li><b>3</b><span><strong>' + esc(T.how_3t) + '</strong>' + esc(T.how_3s) + '</span></li></ol>' +
        '<a class="f7-bn-pill f7-bn-pill--b" href="' + esc(cta) + '">' + esc(T.how_cta) + '</a></div></section>');
    }
    /* FAQ: "Como funciona a Black November?" em primeiro, aberta */
    var faq = $('.f7-h-faq__list');
    if (faq && !$('.f7-bn-faq', faq)) {
      faq.insertAdjacentHTML('afterbegin', '<details class="f7-h-faq__item f7-bn-faq" open><summary><span class="f7-h-faq__no" aria-hidden="true">BN</span><span>' + esc(T.faq_q) + '</span><i class="f7-h-faq__icon" aria-hidden="true"></i></summary>' +
        '<div class="f7-h-faq__a"><p>' + T.faq_a_html + '</p></div></details>');
    }
  };

  /* ---------- Coleção: topo escuro com as cores do clube e o escudo grande a flutuar atrás ---------- */
  var collection = function(){
    var ch = $('.f7-ch.bn-ch');
    if (!ch || !BN) return;
    var COLORS = { '025': ['#e30613', '#ffffff'], '026': ['#0047ab', '#ffffff'], '027': ['#00a651', '#ffffff'], '703': ['#c8102e', '#046a38'],
      '087': ['#d6001c', '#ffffff'], '002': ['#febe10', '#3a2a8c'], '045': ['#a50044', '#004d98'], '004': ['#004170', '#da291c'], '015': ['#6cabdd', '#1c2c5b'] };
    var set = function(a, b){ ch.style.setProperty('--c1', a); ch.style.setProperty('--c2', b); };
    set('#ff6a00', '#ffa21a');
    var crest = ch.getAttribute('data-f7-bn-crest'), code = ch.getAttribute('data-f7-bn-code');
    if (!crest) return;
    /* v17: o escudo grande já vem no HTML da secção (f7-c-hero); só o junta aqui se faltar (cache antiga) */
    if (!$('.bn-ch__mark', ch)) ch.insertAdjacentHTML('afterbegin', '<img class="bn-ch__mark" src="' + esc(crest) + '" alt="" aria-hidden="true">');
    if (COLORS[code]) { set(COLORS[code][0], COLORS[code][1]); return; }
    /* Outros clubes: as duas cores mais fortes do próprio escudo */
    var pic = new Image();
    pic.crossOrigin = 'anonymous';
    pic.onload = function(){
      try {
        var cv = document.createElement('canvas'); cv.width = cv.height = 48;
        var g = cv.getContext('2d'); g.drawImage(pic, 0, 0, 48, 48);
        var d = g.getImageData(0, 0, 48, 48).data, bins = {};
        for (var i = 0; i < d.length; i += 4) {
          var r = d[i], gg = d[i + 1], b = d[i + 2], a = d[i + 3], mx = Math.max(r, gg, b), mn = Math.min(r, gg, b);
          if (a < 200 || mx - mn < 60 || mx < 50) continue;
          var k = [r >> 5, gg >> 5, b >> 5].join();
          var o = bins[k] = bins[k] || { n: 0, r: 0, g: 0, b: 0 };
          o.n++; o.r += r; o.g += gg; o.b += b;
        }
        var top = Object.keys(bins).map(function(k){ return bins[k]; }).sort(function(x, y){ return y.n - x.n; }).map(function(o){ return 'rgb(' + (o.r / o.n | 0) + ',' + (o.g / o.n | 0) + ',' + (o.b / o.n | 0) + ')'; });
        if (top[0]) set(top[0], top[1] || '#ffa21a');
      } catch (e) {}
    };
    pic.src = crest.replace(/width=\d+/, 'width=120');
  };

  ready(function(){
    tickTop();
    decorate(document);
    home();
    collection();
    /* Cartões que chegam depois (vitrines por aba, "ver mais", filtros) */
    var t = null;
    new MutationObserver(function(){ clearTimeout(t); t = setTimeout(function(){ decorate(document); }, 120); }).observe(document.body, { childList: true, subtree: true });
  });
})();
